import EditDivCell from './edit-div-cell'
EditDivCell.install = function (Vue) {
  Vue.component(EditDivCell.name, EditDivCell)
}
export default EditDivCell
